<template>
  <section>
    <HeadingLarge>Cards</HeadingLarge>
    <GridAuto :class="$style.cardSamples">
      <Card>
        <template #header>
          <HeadingSmall>Card Header Slot</HeadingSmall>
        </template>
        <template #body>
          <ParagraphBody>Card Body Slot</ParagraphBody>
        </template>
        <template #footer>
          Card Footer Slot
        </template>
      </Card>
      <CardCta
        :class="$style.cardSample"
        ctaHref="ctaHref"
        ctaText="ctaText"
      >
        <template #header>
          <HeadingSmall>Card Header Slot</HeadingSmall>
        </template>
        <template #body>
          <ParagraphBody>Card Body Slot</ParagraphBody>
        </template>
        <template #footer>
          Card Footer Slot
        </template>
      </CardCta>
      <CardIcon
        :class="$style.cardSticker"
        icon="locked"
      >
        <HeadingSmall>Card Title</HeadingSmall>
        <ParagraphBody>Card Body</ParagraphBody>
      </CardIcon>
    </GridAuto>
  </section>
</template>

<script>
import {
  Card,
  CardCta,
  CardIcon,
  GridAuto,
  HeadingLarge,
  HeadingSmall,
  ParagraphBody,
} from '@jumpcloud/ui-components';

export default {
  name: 'StickerCards',

  components: {
    Card,
    CardCta,
    CardIcon,
    GridAuto,
    HeadingLarge,
    HeadingSmall,
    ParagraphBody,
  },
};
</script>

<style module>
.cardSamples {
  margin-block-end: var(--jc-spacer);
}
</style>
